module.exports = __webpack_public_path__ + "static/media/bigdata.dc4a7a63.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/bigdata.png
// module id = 1561
// module chunks = 0